<i18n src='../../static/localization/map.json'></i18n>
<template>
  <!-- <v-app> -->
  <div class="wrap">
    <v-navigation-drawer
      fixed
      :clipped="clipped"
      v-model="drawer"
      app
    >
      <v-list>
        <v-list-tile @click="" value="true">
          <v-list-tile-action>
            <v-icon class>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title @click="showManagement=true">Mapa cintorína</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile v-show="role==='admin'" @click="showManagement=!showManagement;" value="true">
          <v-list-tile-action>
            <v-icon class>list</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Databáza hrobov</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- <v-divider></v-divider> -->
        <!-- <v-list-tile @click="showAnalytics=!showAnalytics; drawerSide=false" value="true"> -->
        <!-- </v-list-tile> -->
        <!-- <v-divider></v-divider> -->
      </v-list>
    </v-navigation-drawer>



    <v-toolbar fixed app :clipped-left="clipped" class="elevation-0, amber lighten-1">
      <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
      <img :src="adminLogo" alt="erb" class="adminLogo">
      <h3>Informačný systém obce {{adminName}}</h3>
      <v-spacer></v-spacer>
      <v-toolbar-items>
      <logout v-show="role==='admin'" @showProfile=showUserProfile></logout>
    </v-toolbar-items>
    </v-toolbar>
    <!-- <v-content> -->
      <v-container fluid>
          <v-layout>
            <grave-management v-bind:class="{ show: !showManagement }" v-bind:graves="$store.state.graves" @getLayerInfo=getLayerInfo @closeDrawer=closeDrawer></grave-management>
            <profile v-bind:showProfile="showProfile" @show-hide-profile="update"></profile>
            <DeleteGraveModal v-bind:isDialog="dialog" @deleteGrave=deleteGraveFromDb></DeleteGraveModal>
            <div id="map"></div>
          </v-layout>
      </v-container>
      <v-navigation-drawer fixed app right width="400" :clipped="clipped" v-model="drawerSide" class="sidebar" v-show="role==='admin'">
            <v-toolbar-side-icon @click.stop="drawerSide = !drawerSide"></v-toolbar-side-icon>
              <v-card class="ml-3 elevation-0 sidebar-wrapper">
                <!-- <v-card-title primary-title> -->
                  <!-- Hrob c. {{layerProps.graveNumber}} -->
                <!-- </v-card-title> -->
                <v-img>
                  <expandable-image :src="graveImg" v-if="graveImg"/>
                </v-img>
                <v-flex xs11>
                  <v-text-field
                    v-model="graveNumber"
                    name="graveNumber"
                    v-bind:label="placeholders.sidebar[this.$i18n.locale].graveNumber"
                    v-bind:value="graveNumber">
                  </v-text-field>
                </v-flex>

                <v-flex xs11>
                  <v-text-field
                    v-model="owner"
                    name="owner"
                    v-bind:label="placeholders.sidebar[this.$i18n.locale].owner"
                    v-bind:value="owner">
                  </v-text-field>
                </v-flex>

                <v-flex xs11>
                  <v-text-field
                    v-model="ownerAddress"
                    name="ownerAddress"
                    v-bind:label="placeholders.sidebar[this.$i18n.locale].ownerAddress"
                    v-bind:value="ownerAddress">
                  </v-text-field>
                </v-flex>

                <v-flex xs11>
                  <v-text-field
                    v-model="block"
                    name="block"
                    v-bind:label="placeholders.sidebar[this.$i18n.locale].block"
                    v-bind:value="block">
                  </v-text-field>
                </v-flex>

                <v-flex xs11>
                  <v-text-field
                    v-model="graveType"
                    name="graveType"
                    v-bind:label="placeholders.sidebar[this.$i18n.locale].graveType"
                    v-bind:value="graveType">
                  </v-text-field>
                </v-flex>

                <v-flex xs11>
                  <v-text-field
                    v-model="name"
                    name="name"
                    v-bind:label="placeholders.sidebar[this.$i18n.locale].name"
                    v-bind:value="name">
                  </v-text-field>
                </v-flex>

                <v-flex xs11>
                  <v-text-field
                    v-model="rentStart"
                    name="rentStart"
                    v-bind:label="placeholders.sidebar[this.$i18n.locale].rentStart"
                    v-bind:value="rentStart">
                  </v-text-field>
                </v-flex>

                <v-flex xs11>
                  <v-text-field
                    v-model="rentExpire"
                    name="rentExpire"
                    v-bind:label="placeholders.sidebar[this.$i18n.locale].rentExpire"
                    v-bind:value="rentExpire">
                  </v-text-field>
                </v-flex>

              </v-card>
              <v-divider></v-divider>
              <v-btn depressed color="primary" @click="saveChangesToDb(layerProps.properties.id)">
                <v-icon small>fa-save</v-icon>&nbsp; Uložiť zmeny
              </v-btn>
              <v-btn color="error" @click="deleteGrave(layerProps.properties.id)">Zmazať hrob</v-btn>
              <v-list dense class="pt-0">

              </v-list>
            </v-navigation-drawer>
    <!-- </v-content> -->
    <!-- <v-footer :fixed="fixed" app>
      <span>&copy; 2017</span>
    </v-footer> -->
  </div>
  <!-- </v-app> -->

</template>
<script>
import { HTTP } from '../common/http'
import { placeholders } from '../../static/localization/placeholders'
import L from 'leaflet'
import 'leaflet.gridlayer.googlemutant'
import 'leaflet.vectorgrid'
import '../../static/lib/leaflet-measure'
import '../../static/lib/leaflet-draw/leaflet.draw-src'
import { mapState, mapMutations } from 'vuex'
import moment from 'moment'
import GraveManagement from './GraveManagement'
import VueExpandableImage from 'vue-expandable-image'
import Profile from './Profile'
import Logout from './Logout'
import DeleteGraveModal from './DeleteGraveModal'
// BASEMAPS
const baseMaps = {
  'Google Satellite': L.gridLayer.googleMutant({ type: 'satellite' }),
  'Google Hybrid': L.gridLayer.googleMutant({ type: 'hybrid' })
}

export default {
  name: 'map',
  components: {
    GraveManagement,
    DeleteGraveModal,
    Profile,
    Logout
  },
  data() {
    return {
      adminName: localStorage.name,
      adminLogo: localStorage.logo,
      adminWmsUrl: localStorage.wmsUrl,
      adminWmsLayer: localStorage.wmsLayer,
      adminLat: localStorage.center.split(',')[0],
      adminLon: localStorage.center.split(',')[1],
      role: localStorage.role,
      isActive: true,
      showManagement: true,
      showProfile: false,
      layersOn: [], // list of all switched on layers id
      layerProps: {},
      graveNumber: 0,
      graveImg: '',
      owner: '',
      ownerAddress: '',
      block: '',
      graveType: '',
      name: '',
      color: '',
      rentStart: new Date(),
      rentExpire: new Date(),
      layerComposition: new L.LayerGroup(),
      drawnItems: new L.FeatureGroup(),
      map: {},
      clipped: true,
      drawer: true,
      drawerSide: false,
      fixed: false,
      right: true,
      rightDrawer: false,
      layers: this.$store.getters.getGraves,
      placeholders: placeholders,
      grave: {},
      clickedLayer: {},
      locale: 'sk',
      dialog: false,
      graveIdToDelete: ''
    }
  },
  mounted() {
    // this.$i18n.locale = 'sk'
    const map = L.map('map', {
      center: [this.adminLat, this.adminLon],
      zoom: 19,
      // drawControl: true,
      layers: [baseMaps['Google Hybrid']],
      zoomControl: false
    })
    L.control
      .scale({
        metric: true,
        imperial: false,
        position: 'bottomright'
      })
      .addTo(map)
    L.control.zoom({ position: 'bottomright' }).addTo(map)
    const measure = new L.Control.Measure({
      position: 'bottomright',
      lengthUnit: 'meters',
      decPoint: '.',
      primaryLengthUnit: 'meters',
      primaryAreaUnit: 'sqmeters',
      secondaryAreaUnit: undefined,
      secondaryLengthUnit: undefined,
      popupOptions: {
        className: 'leaflet-measure-resultpopup',
        autoPanPadding: [10, 10]
      }
    })
    measure.addTo(map)
    this.measureLanguage()
    L.control.layers(baseMaps, null, { collapsed: true }).addTo(map)
    this.layerComposition.addTo(map)
    this.drawnItems.addTo(map)
    if (this.role === 'admin') {
      new L.Control.Draw({
        draw: {
          polyline: false,
          rectangle: false,
          circle: false,
          marker: false,
          circlemarker: false
        },
        edit: {
          featureGroup: this.drawnItems,
          remove: false,
          edit: false
        }
      }).addTo(map)
    }
    L.drawLocal.draw.toolbar.buttons.polygon = 'Začnite kresliť polygón'
    L.drawLocal.draw.toolbar.actions.title = 'Zrušiť kreslenie'
    L.drawLocal.draw.toolbar.actions.text = 'Zrušiť'
    L.drawLocal.draw.toolbar.finish.title = 'Dokončiť kreslenie'
    L.drawLocal.draw.toolbar.finish.text = 'Dokončiť'
    L.drawLocal.draw.toolbar.undo.text = 'Zmazať posledný bod'
    L.drawLocal.draw.toolbar.undo.title = 'Zmazať posledný bod'
    L.drawLocal.draw.handlers.polygon.tooltip.start = 'Kliknutím do mapy začnete kresliť polygón'
    L.drawLocal.draw.handlers.polygon.tooltip.cont = 'Pokračujte v kreslení ďalším klikom'
    L.drawLocal.draw.handlers.polygon.tooltip.end = 'Kliknutím na prvý bod uzavriete polygón'
    L.drawLocal.edit.toolbar.actions.save.title = 'Uložiť zmeny'
    L.drawLocal.edit.toolbar.actions.save.text = 'Uložiť'
    L.drawLocal.edit.toolbar.actions.cancel.title = 'Zrušiť zmeny'
    L.drawLocal.edit.toolbar.actions.cancel.text = 'Zrušiť'
    L.drawLocal.edit.toolbar.buttons.edit = 'Upraviť vrstvy'
    L.drawLocal.edit.toolbar.buttons.editDisabled = 'Žiadne vrstvy na upravenie'
    L.drawLocal.edit.handlers.edit.tooltip.text = 'Pre upravenie polygónu potiahni jeho body'
    L.drawLocal.edit.handlers.edit.tooltip.subtext = 'Klikni na Zrušiť pre zrušenie zmien'

    this.map = map
    this.drawLayer()
    this.getGraves()
    this.addRasterToMap()
  },
  watch: {
    drawer: function() {
      this.map.invalidateSize()
    }
  },
  methods: {
    ...mapMutations(['loadGraves', 'setGraveProperty']),
    deleteModal: function (value) {
      this.$emit('deleteModal', value)
    },
    getGraves: async function() {
      return new Promise(resolve => {
        HTTP.get('/graves', {
          params: {
            id: localStorage.id
          }
        })
          .then(response => {
            response.data.data.forEach(o => {
              o.properties.rentStartTs = moment(o.properties.rentStart, 'DD-MM-YYYY').valueOf()
              o.properties.rentExpireTs = moment(o.properties.rentExpire, 'DD-MM-YYYY').valueOf()
            })
            this.$store.commit('loadGraves', response.data.data)
            this.addGeoJSONToMap()
          })
          .catch(error => console.error(error))
      })
    },
    addRasterToMap: function() {
      const tileLayer = L.tileLayer.wms(this.adminWmsUrl, {
        layers: this.adminWmsLayer,
        format: 'image/png',
        tms: true,
        zIndex: 99,
        maxZoom: 29,
        transparent: true,
        continuousWorld: true
      })
      this.map.addLayer(tileLayer, true)
    },
    addGeoJSONToMap: function() {
      const that = this
      let gravesLayer
      // this.$store.getters.getGraves.filter(grave => {
      //   gravesLayer = L.geoJSON(grave, {
      //     onEachFeature: (feature, layer) => {
      //       layer.bindTooltip(feature.properties.graveNumber.toString(), { permanent: false, direction: 'center', className: 'toolTipStyle' })

      //       if (feature.properties.name) {
      //         layer.bindPopup(
      //           '<p>Mená pochovaných: ' +
      //             feature.properties.name +
      //             '</p><p>Nájomník: ' +
      //             feature.properties.owner +
      //             '</p>'
      //         )
      //         layer.on('mouseover', () => {
      //           layer.openPopup()
      //         })
      //         layer.on('mouseout', () => {
      //           layer.closePopup()
      //         })
      //       }

      //       layer.on('click', () => {
      //         this.clickedLayer = layer
      //         this.getLayerInfo(feature.properties.id)
      //         that.drawerSide = true
      //       })
      //     }
      //   }).addTo(this.layerComposition)
      // })

      let lastZoom
      that.map.on('zoomend', function() {
          const zoom = that.map.getZoom()
          if (zoom < 20 && (!lastZoom || lastZoom >= 20)) {
              that.map.eachLayer(function(l) {
                  if (l.getTooltip()) {
                      let tooltip = l.getTooltip();
                      l.unbindTooltip().bindTooltip(tooltip, {
                          permanent: false
                      })
                  }
              })
          } else if (zoom >= 20 && (!lastZoom || lastZoom < 20)) {
              that.map.eachLayer(function(l) {
                  if (l.getTooltip()) {
                      let tooltip = l.getTooltip();
                      l.unbindTooltip().bindTooltip(tooltip, {
                          permanent: true
                      })
                  }
              });
          }
          lastZoom = zoom;
      })

      const gravesVectorLayer = L.vectorGrid.slicer(
        {
          "type":"FeatureCollection",
          "features": this.$store.getters.getGraves }, {
            interactive: true,
            maxZoom: 28,
            getFeatureId: function(f) {
              return f.properties.graveNumber
            },
            vectorTileLayerStyles: {
              sliced: (properties) => {
                return {
                  fill: true,
                  fillOpacity: 0.1,
                  fillColor: properties.color ? properties.color : '#FFFFFF',
                  color: properties.color ? properties.color : '#FFFFFF'
                }
              }
            }
        },{
          
        }
      )
      gravesVectorLayer.addTo(this.layerComposition)
      const popup = L.popup()
      gravesVectorLayer
      .on('click', (e) => {
        if (this.role === 'admin') {
          this.clickedLayer = e.layer
          this.getLayerInfo(e.layer.properties.id)
          that.drawerSide = true
        }
      })
      .on('mouseover', (e) => {
        let popupContent = ''
        if (e.layer.properties.name) popupContent=popupContent + `<p>Mená pochovaných: ${e.layer.properties.name}</p>`
        if (e.layer.properties.owner) popupContent=popupContent +`<p>Nájomník: ${e.layer.properties.owner}</p>`
        popup.setContent(popupContent).setLatLng(e.latlng).openOn(this.map)
      })
      .on('mouseout', (e) => {
        that.map.closePopup(popup)
      })
      gravesVectorLayer.bringToFront()
    },
    getLayerInfo: function(id) {
      this.layerProps = this.$store.getters.getGraves.filter(l => l.properties.id === id)[0]
      this.graveNumber = this.layerProps.properties.graveNumber
      this.owner = this.layerProps.properties.owner
      this.ownerAddress = this.layerProps.properties.ownerAddress
      this.block = this.layerProps.properties.block
      this.graveType = this.layerProps.properties.graveType
      this.name = this.layerProps.properties.name
      this.rentStart = this.layerProps.properties.rentStart
      this.rentExpire = this.layerProps.properties.rentExpire
      this.graveImg = this.layerProps.properties.graveImg ? this.layerProps.properties.graveImg : null
    },
    toggleModel: function(element, array) {
      if (!array.includes(element)) {
        array.push(element)
      } else {
        array.splice(array.indexOf(element), 1)
      }
    },
    measureLanguage: function() {
      document.getElementsByClassName('js-startprompt startprompt')[0].children[0].innerHTML =
        placeholders.leafletMeasurement[this.$i18n.locale].measure
      document.getElementsByClassName('js-starthelp')[0].innerHTML =
        placeholders.leafletMeasurement[this.$i18n.locale].startCreating
      document.getElementsByClassName('js-cancel')[0].innerHTML =
        placeholders.leafletMeasurement[this.$i18n.locale].cancel
      document.getElementsByClassName('js-finish')[0].innerHTML =
        placeholders.leafletMeasurement[this.$i18n.locale].finish
      document.getElementsByClassName('js-start')[0].innerHTML =
        placeholders.leafletMeasurement[this.$i18n.locale].create
    },
    saveChanges: function(id, key, newProps) {
      const payload = {
        graveId: id,
        key: key,
        value: newProps
      }
      this.$store.commit('setGraveProperty', payload)
    },
    saveChangesToDb: async function(id) {
      // const record = this.$store.getters.getGraves.filter(grave => grave.properties.id === id)[0].properties
      // const { graveNumber, block, graveType, name, owner, ownerAddress, rentStart, rentExpire } = record
      HTTP.put('/graves/' + id, {
        adminId: localStorage.id,
        graveNumber: this.graveNumber,
        block: this.block,
        graveType: this.graveType,
        name: this.name,
        owner: this.owner,
        ownerAddress: this.ownerAddress,
        rentStart: this.rentStart,
        rentExpire: this.rentExpire,
        id: id
      }).then(response => {
        this.graveNumber = 0
        this.drawerSide = !this.drawerSide
        this.getGraves().then()
      }).catch(err => console.error(err))
    },
    closeDrawer: function() {
      this.drawerSide = true
    },
    drawLayer: function() {
      this.map.on('draw:created', e => {
        const type = e.layerType
        const layer = e.layer
        this.drawnItems.addLayer(layer)
        const newLayer = layer.toGeoJSON()
        this.saveDrawnLayer(newLayer, layer)
      })
    },
    saveDrawnLayer: function(newLayer, layer) {
      newLayer.properties.adminId = localStorage.id
      HTTP.post('/graves', newLayer)
        .then(response => {
          this.getGraves().then()
          // layer.properties = {}
          // layer.properties.id = response.data._id
          layer.on('click', () => {
            this.clickedLayer = layer
            this.drawerSide = true
            this.getLayerInfo(response.data.properties.id)
          })
        })
        .catch(error => console.error(error))
    },
    deleteGrave: function(id) {
      this.dialog = true
      this.graveIdToDelete = id
      this.drawerSide = true
    },
    deleteGraveFromDb: function (id) {
      HTTP.delete('/graves/' + this.graveIdToDelete).catch(err => console.error(err))
      this.dialog = false
      this.map.removeLayer(this.clickedLayer)
      this.layerComposition.clearLayers()	
      this.getGraves()
      this.drawerSide = !this.drawerSide
    },
    showUserProfile: function() {
      this.showProfile = !this.showProfile
    },
    update: function (show) {
      this.showProfile=show;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../static/style/leaflet.css';
@import '../../static/style/leaflet-measure.css';
@import '../../static/lib/leaflet-draw/leaflet.draw-src.css';

#map {
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 0;
}
.wrap {
  height: 100%;
  width: 100%;
}
.content {
  padding: 0 !important;
}
.show {
  display: block !important;
}
.hide {
  display: none !important;
}
.container {
  height: 100%;
  width: 100%;
  padding: 0px;
}
.layout {
  height: 100%;
  width: 100%;
  display: -webkit-box;
}

.sidebar {
  max-height: none !important;
  overflow-y: auto;
}
.toolbar__items {
  margin-right: 0px !important;
}
.adminLogo {
  width: 40px;
  height: auto;
  margin-right: 20px;
}

.grave-img {
  max-width: 170px;
}

.sidebar-wrapper {
  text-align: center;
  margin-left: 0px !important;
}

.sidebar-wrapper > * {
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/components/Map.vue